import { FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMNS } from 'pages/FundInvestments/common/constants';
import { getNumberValue, getObjectValue } from 'utilities';
import { ReverseParserParams } from './createReverseParser.types';
import { updateFieldValue } from './utils';

const {
  capital_account_date: CAPITAL_ACCOUNT_DATE,
  committed_capital: COMMITTED_CAPITAL,
  invested_capital: INVESTED_CAPITAL,
  realized_income: REALIZED_INCOME,
  unrealized_income: UNREALIZED_INCOME,
  distributions: DISTRIBUTIONS,
  net_capital: NET_CAPITAL,
  market_adjustment: MARKET_ADJUSTMENT,
  concluded_fair_value_of_net_capital: CONCLUDED_FAIR_VALUE_OF_NET_CAPITAL,
} = FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMNS;

const createReverseParser = (params: ReverseParserParams): void => {
  const { cells, fieldAttributes, setFundInvestmentDetails } = params;

  Object.values(cells).forEach(cell => {
    const { data, isTitleCell, y: colIndex } = getObjectValue(cell);
    const { fundInvestmentUuid } = getObjectValue(data);

    const colNumber = getNumberValue(colIndex) + 1;

    // Handle investment vehicle cells
    if (fundInvestmentUuid) {
      switch (colNumber) {
        case CAPITAL_ACCOUNT_DATE.column:
          // Handle fund selection
          if (isTitleCell) {
            updateFieldValue({
              cell,
              fieldAttributes,
              field: 'fund',
              fundInvestmentUuid,
              setFundInvestmentDetails,
            });
          } else {
            // Handle capital account date
            updateFieldValue({
              cell,
              fieldAttributes,
              field: 'capital_account_date',
              fundInvestmentUuid,
              setFundInvestmentDetails,
            });
          }
          break;

        case COMMITTED_CAPITAL.column:
          updateFieldValue({
            cell,
            fieldAttributes,
            field: 'commited_capital',
            fundInvestmentUuid,
            setFundInvestmentDetails,
          });
          break;

        case INVESTED_CAPITAL.column:
          updateFieldValue({
            cell,
            fieldAttributes,
            field: 'invested_capital',
            fundInvestmentUuid,
            setFundInvestmentDetails,
          });
          break;

        case REALIZED_INCOME.column:
          updateFieldValue({
            cell,
            fieldAttributes,
            field: 'realized_income',
            fundInvestmentUuid,
            setFundInvestmentDetails,
          });
          break;

        case UNREALIZED_INCOME.column:
          updateFieldValue({
            cell,
            fieldAttributes,
            field: 'unrealized_income',
            fundInvestmentUuid,
            setFundInvestmentDetails,
          });
          break;

        case DISTRIBUTIONS.column:
          updateFieldValue({
            cell,
            fieldAttributes,
            field: 'distributions',
            fundInvestmentUuid,
            setFundInvestmentDetails,
          });
          break;

        case NET_CAPITAL.column:
          updateFieldValue({
            cell,
            fieldAttributes,
            field: 'net_capital',
            fundInvestmentUuid,
            setFundInvestmentDetails,
          });
          break;

        case MARKET_ADJUSTMENT.column:
          updateFieldValue({
            cell,
            fieldAttributes,
            field: 'market_adjustment',
            fundInvestmentUuid,
            setFundInvestmentDetails,
          });
          break;

        case CONCLUDED_FAIR_VALUE_OF_NET_CAPITAL.column:
          updateFieldValue({
            cell,
            fieldAttributes,
            field: 'concluded_fair_value_of_net_capital',
            fundInvestmentUuid,
            setFundInvestmentDetails,
          });
          break;

        default:
          break;
      }
    }
  });
};

export default createReverseParser;
